import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const CloseModalElementV1 = z.object({
  id: z.string(),
  name: z.literal("closeModal"),
  children: z.lazy(() => z.array(Element)),
  settings: z.object({
    initialStyles: z.object({}).passthrough().optional(),
  }),
})

export type TCloseModalElementV1 = z.infer<typeof CloseModalElementV1>

// Latest ---------------------
export const CloseModalElement = CloseModalElementV1
export type TCloseModalElement = TCloseModalElementV1
